import React from 'react';
import { Box } from '@enaep-ng/benchmark';
import * as styleSheet from '../styles';

const Footer = (props: { primary: boolean }) => {
  return (
    <Box style={styleSheet.footerContainer}>
      <Box style={{
        overflow: "hidden",
        height: "calc(78px * var(--zoom))",
        position: "relative"
      }}>
        <Box style={{
          width: "calc(1366px * var(--zoom))",
          height: "calc(69px * var(--zoom))",
          padding: "calc(2px * var(--zoom))",
          backgroundColor: "#ffffff",
          boxSizing: "border-box",
          boxShadow: "0px calc(1px * var(--zoom)) calc(6px * var(--zoom)) calc(-2px * var(--zoom)) rgba(0, 0, 0, 0.35)",
          position: "absolute",
          bottom: "100%",
          left: "0",
          zIndex: "1"
        }} />
        {props.primary ? (
          <Box style={{...styleSheet.footerPrimaryBackground, height: '58px'}} />
        ) : (
          <Box style={styleSheet.footerBackground} />
        )}
        <Box style={{
          height: "calc(20px * var(--zoom))",
          backgroundColor: "#485496"
        }} />
      </Box>
    </Box>
  );
};
export default Footer;
